// Order is potentially important here
/* eslint-disable perfectionist/sort-imports */
import 'reset.css/reset.css';
import '@rescui/typography/lib/font-jb-sans-auto.css';
/* eslint-enable perfectionist/sort-imports */

import FocusManager from '@rescui/focus-manager';

export const onInitialClientRender = () => {
  new FocusManager();
};
